import React from 'react';

import { Container } from './styles';
import { logo } from '../../../../../config';

interface ILoaderProps {
  message: string;
  position?: 'fixed' | 'relative' | 'absolute';
}

const Loader: React.FC<ILoaderProps> = ({
  message = 'Carregando...',
  position = 'fixed',
}) => {
  return (
    <Container position={position}>
      <aside style={{ background: '#fff', padding: '20px', borderRadius: '15px', margin: '20px auto' }}><img alt="Plataforma Online" src={logo} /></aside>
      <aside style={{ background: '#fff', padding: '5px', borderRadius: '10px', color: '#333' }}>{message}</aside>
    </Container>
  );
};

interface ILoaderWithElementProps {
  message: JSX.Element;
  position?: 'fixed' | 'relative' | 'absolute';
}

export const LoaderWithElement: React.FC<ILoaderWithElementProps> = ({
  message = <>Carregando...</>,
  position = 'fixed',
}) => {
  return (
    <Container position={position}>
      <aside style={{ background: '#fff', padding: '20px', borderRadius: '15px', margin: '20px auto' }}><img alt="Plataforma Online" src={logo} /></aside>
      <aside style={{ background: '#fff', padding: '5px', borderRadius: '10px', color: '#333' }}>{message}</aside>
    </Container>
  );
};

export default Loader;
